import numeral from 'numeral'

export function amountFilter (value: number): string {
  return typeof value !== 'number' ? value : value.toFixed(2)
}
export function statFilter (value: number): string {
  return typeof value !== 'number' ? value : value.toFixed(1)
}
export function rankFilter (value: number): string {
  return numeral(value).format('Oo')
}
